import axios from 'axios';

import mimeTypes from '@/utils/mimeTypes';

const DEFAULT_FILE_EXTENSION = 'jpg';

export default function useFileDownload() {
  function findExtensionFromMimeType(mimeType: string) {
    return mimeTypes[mimeType];
  }

  function getFileExtension(url: string, contentType: string) {
    if (contentType) {
      return findExtensionFromMimeType(contentType);
    }

    if (url) {
      return url.split('.').pop();
    }

    return DEFAULT_FILE_EXTENSION;
  }

  async function download(url: string, filename?: string) {
    const fileLink = document.createElement('a');
    try {
      const response = await axios.get<BlobPart>(
        url.replace('http://', 'https://'),
        {
          method: 'GET',
          responseType: 'blob',
        }
      );

      const contentType = response.headers['content-type'] as string;
      const extension = getFileExtension(url, contentType);

      if (!filename) {
        filename = new Date().toLocaleString('en-US');
      }

      const fileURL = window.URL.createObjectURL(new Blob([response.data]));

      fileLink.href = fileURL;
      fileLink.setAttribute('download', `${filename}.${extension}`);
      document.body.appendChild(fileLink);
      fileLink.click();
    } catch (error) {
      fileLink.href = url;
      fileLink.target = '_blank';
      document.body.appendChild(fileLink);
      fileLink.click();
    } finally {
      document.body.removeChild(fileLink);
    }
  }

  return { download };
}
